(function () {
  'use strict';

  angular
    .module('services.sprintfService', [])
    .factory('sprintfService', sprintfService);

  sprintfService.$inject = ['$window'];

  function sprintfService($window) {

    return {
      sprintf: $window.sprintf,
      vsprintf: $window.vsprintf
    };
  }
})();
